import type { ReactNode } from 'react';

/**
 * A label/value pair used inside the map hover cards (PoiPopup, AirValvePopup) so the two cards
 * share one definition and can't drift. `meta` renders as a muted parenthetical suffix after the
 * label (e.g. "(Original)").
 */
export function HoverCardField({ label, meta, value }: { label: string; meta?: string; value: ReactNode }) {
    return (
        <div className="space-y-0.5">
            <p className="text-foreground text-sm font-medium">
                {label}
                {meta && <span className="text-muted-foreground font-normal"> {meta}</span>}
            </p>
            <div className="text-muted-foreground text-sm">{value}</div>
        </div>
    );
}
